/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import IconBack from '../../assets/Images/icons/icon-back';
import RopaService from '../../services/Ropa.service';
import UserService from '../../services/UserService';
import ActivityProcess from './components/RopaDetail/components/Activity';
import Risk from './components/RopaDetail/components/Risk';
import Secret from './components/RopaDetail/components/Secret';
import Detail from './components/RopaDetail/Detail';
import TabsDetail from './components/RopaDetail/Tabs';
import { STATUS_ID } from './STATUS_ID';
import { ROUTER } from '../../constants/router';
import Comment from '../data-flow/components/Comment';
import usePermission from '../../hooks/usePermission';

export default function RopaDetail() {
    const { t } = useTranslation();
    let navigate = useNavigate();
    let { activityId, ropa } = useParams();

    const [detail, setDetail] = useState([]);
    const [detailInfo, setDetailInfo] = useState();
    const [editMode, setEditMode] = useState(false);
    const [openTabDB, setOpenTabDB] = useState(false);
    const [storageLocation, setStorageLocation] = useState([]);

    // Role
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);

    const getRopaDetail = async () => {
        try {
            const { data } = await RopaService.getRopaDetail(activityId);
            if (data?.resultData) {
                setDetail(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const getRoPaDetailHeader = async () => {
        try {
            const { data } = await RopaService.getRoPaDetailHeader(activityId);
            if (data?.resultData) {
                setDetailInfo(data.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (ropa) {
            setEditMode(false);
        } else {
            if (detailInfo) {
                if (admin) {
                    if (
                        detailInfo.statusId === STATUS_ID.WAITING_FOR_REVIEW ||
                        detailInfo.statusId === STATUS_ID.DRAFT
                    ) {
                        //Waiting for Review
                        setEditMode(true);
                    } else {
                        setEditMode(false);
                    }
                } else {
                    //Waiting for Review and Reviewed
                    if (
                        detailInfo.statusId === STATUS_ID.WAITING_FOR_REVIEW ||
                        detailInfo.statusId === STATUS_ID.REVIEWED
                    ) {
                        setEditMode(false);
                    } else {
                        setEditMode(true);
                    }
                }
            }
        }
    }, [admin, detailInfo]);

    useEffect(async () => {
        await getRopaDetail();
        getRoPaDetailHeader();
        getMasterStorageLocation();
    }, [activityId]);

    const getMasterStorageLocation = async () => {
        try {
            const { data } = await RopaService.getMasterStorageLocation(
                activityId
            );
            if (data?.resultData) {
                setStorageLocation(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (detail && storageLocation.length > 0) {
            detail?.collectDataDestruction?.storageLocation?.forEach((e) => {
                if (e) {
                    const result = storageLocation.filter(
                        (data) => data.id === e
                    );
                    if (result?.length > 0) {
                        if (result[0].name === 'Database (ฐานข้อมูล)') {
                            setOpenTabDB(true);
                        }
                    }
                }
            });
        }
    }, [detail, storageLocation]);

    const { isAuditor } = usePermission();

    useEffect(() => {
        if (isAuditor) {
            navigate(ROUTER.DS_INVENTORY.ROPA + '/' + activityId + '/view');
        }
    }, [isAuditor]);

    return (
        <div>
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        navigate(ROUTER.DS_INVENTORY.ROPA);
                    }}
                >
                    <IconBack />
                </div>
                {t('RoPA.RecordOfProcessingActivityDetail')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Inventory')} /{' '}
                    {t('RoPA.RecordOfProcessingActivity')} /{' '}
                </span>
                <span>{t('RoPA.RecordOfProcessingActivityDetail')}</span>
            </div>
            <div className="mt-6">
                <Detail
                    detailInfo={detailInfo}
                    detail={detail}
                    getRoPaDetailHeader={getRoPaDetailHeader}
                    secretLevelId={detailInfo?.secretLevelId}
                />
                <div className="grid grid-cols-3 gap-4">
                    <TabsDetail
                        detail={detail}
                        getRopaDetail={getRopaDetail}
                        openTabDB={openTabDB}
                        storageLocation={storageLocation}
                    />
                    <div>
                        {detailInfo?.comment && (
                            <Comment comment={detailInfo?.comment} />
                        )}
                        <div
                            hidden={detailInfo?.statusId !== STATUS_ID.REVISE}
                            className="bg-[#FFECF0] p-4 mt-4 rounded-xl"
                        >
                            <div className="text-[#F0536F] font-semibold text-sm">
                                {t('RR.ReasonForRevise')}
                            </div>
                            <div className="my-4 border-2 border-solid border-[#FFCFD8]"></div>
                            <div>{detailInfo?.reason}</div>
                        </div>
                        <Risk
                            editMode={editMode}
                            detail={detail}
                            detailInfo={detailInfo}
                        />
                        <Secret
                            editMode={editMode}
                            secretLevelId={detailInfo?.secretLevelId}
                            getRoPaDetailHeader={() =>
                                getRoPaDetailHeader(activityId)
                            }
                        />
                        <ActivityProcess
                            activityId={activityId}
                            getRoPaDetailHeader={getRoPaDetailHeader}
                            getRopaDetail={getRopaDetail}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
